import { ProjectSettingsApi } from 'api/ProjectSettingsApi';
import { backendApiClient } from 'container/backendApiClient';

export const projectSettingsApi: ProjectSettingsApi = new ProjectSettingsApi(backendApiClient);
